import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { AuthService } from '@core/services/core/auth/auth.service';
import { ContextService } from '@core/services/core/context.service';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';
import { AllFeatureFlags } from '@models/mmobile';
import { User } from '@core/models/user';
import { TeCuidamosHelper } from '@core/services/helpers/teCuidamos-helper.service';

@Component({
  selector: 'app-tecuidamos-presentation',
  templateUrl: './tecuidamos-presentation.component.html',
  styleUrls: ['../tecuidamos-home/tecuidamos-home.component.scss']
})
export class TecuidamosPresentationComponent implements OnInit {
  @Output() navigateTo = new EventEmitter();
  teCuidamosSavia: boolean;
  user: User;

  constructor(
    public ctx: ContextService,
    public auth: AuthService,
    private mmobileHelper: MMobileHelperService,
    private teCuidamosHelper: TeCuidamosHelper
  ) {}

  ngOnInit() {
    this.teCuidamosSavia = this.mmobileHelper.checkIsFeatureEnabled(AllFeatureFlags.TECUIDAMOS_SAVIA);
    this.user = this.auth.getState().user;
  }

  onClicked() {
    this.navigateTo.emit('signup');
  }

  onOpenSaviaRegisterTecuidamos() {
    this.teCuidamosHelper.openSaviaTeCuidamosUrl('subscribeTeCuidamos');
  }
}
